import { render, staticRenderFns } from "./VideoChat.vue?vue&type=template&id=38f9f86e&scoped=true"
import script from "./VideoChat.vue?vue&type=script&lang=js"
export * from "./VideoChat.vue?vue&type=script&lang=js"
import style0 from "./VideoChat.vue?vue&type=style&index=0&id=38f9f86e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f9f86e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
